import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { PartialLabelData } from '../../../api';
import { useLanguage } from '../../../utils/GeneralUtils';

interface DescriptionSectionProps {
  description: PartialLabelData;
}

export const DescriptionSection = ({ description }: DescriptionSectionProps) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const language = useLanguage();

  const content = description[language];

  if (!content) {
    return null;
  }

  return (
    <Box
      sx={{
        marginBottom: isSmallScreen ? 4 : 5,
        lineHeight: 1.7,
        '& *': {
          fontFamily: 'inherit !important',
          fontSize: 'inherit !important',
        },
        '& p': {
          marginBottom: 2,
        },
        '& ul, & ol': {
          paddingLeft: 3,
          marginBottom: 2,
        },
        '& li': {
          marginBottom: 1,
        },
      }}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};
